import React from 'react';
import { Stack, Text } from '@moda/om';
import { OrderItemReturnPolicy } from '../../../constants';
import { LineItemReturnPolicyHeader } from '../../ReturnPolicyInformation';

import './LineItemReturnPolicy.scss';

interface Props {
  returnPolicy: string | undefined;
  returnPolicyCode: OrderItemReturnPolicy;
  className?: string;
}
export const LineItemReturnPolicy: React.FC<Props> = ({
  returnPolicy,
  returnPolicyCode,
  className
}) => {
  if (!returnPolicy) return null;

  return (
    <Stack space={2} className={className}>
      <LineItemReturnPolicyHeader returnPolicyCode={returnPolicyCode} />

      <Text>{returnPolicy}</Text>
    </Stack>
  );
};
